import { PortalDesignMode } from '../enums/portal-design-mode.enum';
import { IdentityModel } from '../models/identity.model';

/** PROVISIONAL Unified Code (Platforms Code) token values.
 *  Source: @platformscode/core@0.0.52 dist/core/core.css (--colors-primary-sa-flag-600-primary, -700, --colors-base-white).
 *  Not yet verified against design.dga.gov.sa (unreachable at analysis time). See tms-unified-code-analysis.md §4.3 and §17.3.
 *  Font: IBM Plex Sans Arabic is applied by styles/unified-code/_unified-code.scss under html.design-unified-code.
 *  These values must equal --uc-bg-primary / --uc-bg-primary-hover / --uc-color-white in styles/unified-code/_tokens.scss
 *  (primary-600, primary-700, white; textOnColor = --uc-text-on-color = white). */
export const UNIFIED_CODE_TOKENS = {
  primary: '#1b8354',        // --uc-bg-primary (primary-600); replaces identity colorOne  (--identity-primary-400)
  primaryHover: '#166a45',   // --uc-bg-primary-hover (primary-700); replaces identity colorTwo  (--identity-primary-500)
  background: '#ffffff',     // --uc-color-white; replaces identity colorThree (--identity-background)
  textOnColor: '#ffffff',    // --uc-text-on-color (white); on-colour text (hero text over image/colour)
} as const;

export const UNIFIED_CODE_ROOT_CLASS = 'design-unified-code';

/** Missing or unknown `designMode` (older backends) is treated as Custom. */
export function isUnifiedCode(model: { designMode?: PortalDesignMode } | null | undefined): boolean {
  return model?.designMode === PortalDesignMode.UnifiedCode;
}

/** Resolves the effective identity: in Unified Code mode returns a copy with the locked
 *  custom values (colours, pattern) replaced; in Custom mode returns the model unchanged. */
export function resolveIdentity<T extends IdentityModel>(model: T): T {
  if (!isUnifiedCode(model)) return model;

  return {
    ...model,
    colorOne: UNIFIED_CODE_TOKENS.primary,
    colorTwo: UNIFIED_CODE_TOKENS.primaryHover,
    colorThree: UNIFIED_CODE_TOKENS.background,
    pattern: null,
  };
}
